import { render, staticRenderFns } from "./CreateBank.vue?vue&type=template&id=dd3b3c1c&"
import script from "./CreateBank.vue?vue&type=script&lang=ts&"
export * from "./CreateBank.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports